import { Button } from 'antd'
import React from 'react'

function DangerButton({children}) {
  return (
    <Button danger className='auf-button'>{children}</Button>
  )
}

export default DangerButton